import { useState, useContext } from "react";
import api, { fetchCurrentUser, generateQr, login } from "../api";
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../constants";
import styles from "./LoginForm.module.scss";
import { AppContext } from "../AppContext";
import { useMutation } from "@tanstack/react-query";
import { AuthContext } from "../AuthContext";

function LoginForm() {
  // const { setContext } = useContext(AppContext);
  const { username, setUsername, password, setPassword } =
    useContext(AuthContext);

  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: () => login(username, password),
    onSuccess: (data) => {
      const isQrEnabled = data.is_qr_generated;
      if (isQrEnabled) {
        navigate("/verify-2fa");
      } else {
        navigate("/2fa-qr");
      }
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setLoading(true);
    loginMutation.mutate();

    // try {
    //   const res = await api.post(route, { username, password });
    //   localStorage.setItem(ACCESS_TOKEN, res.data.access);
    //   localStorage.setItem(REFRESH_TOKEN, res.data.refresh);
    //   const user = await fetchCurrentUser();
    //   localStorage.setItem("user", JSON.stringify(user));
    //   setContext();
    //   navigate("/");
    // } catch (error) {
    //   alert(error);
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <div className="container">
      <div className={styles.login_form}>
        <h1 className={styles.h1}>C.M.T. Web App</h1>
        <form className={styles.form}>
          <input
            className={styles.input}
            type="text"
            placeholder="Username o Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            className={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="button" onClick={handleSubmit} type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
